
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/account-details",
      function () {
        return require("private-next-pages/account/account-details/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/account-details"])
      });
    }
  